<script lang="ts">
  import { Card, Col, Row } from "sveltestrap"
  import CurrencyBadge from "./CurrencyBadge.svelte"
  import { getPairDetail } from "../stores/query"
  import { chart } from "svelte-apexcharts"

  let chartOptions = {
    chart: {
      type: "line",
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
    stroke: {
      curve: "smooth",
    },
    colors: ["#dbff00"],
    tooltip: {
      enabled: false,
    },
    series: [
      {
        data: [
        ],
      },
    ],
    xaxis: {
      type: "datetime",
    },
  }

  let baseTokenSymbol = '';

  $: try {
    if (!$getPairDetail.fetching) {
      const newOptions = JSON.parse(JSON.stringify(chartOptions))
      for (let i = $getPairDetail.data.pair.pairHourData.length; i > 0; i--) {
        const row = $getPairDetail.data.pair.pairHourData[i - 1]
        newOptions.series[0].data.push(
          {
            x: Number.parseInt(row.periodStart) * 1000,
            y: Number.parseFloat(row.open).toFixed(2),
          }
        )
      }
      chartOptions = newOptions
      baseTokenSymbol = $getPairDetail.data.pair.baseToken.symbol
    }
  } catch (e) {
    console.error(e);
  }
</script>

<Card class="info-card stat">
  <Row class="align-items-center stat-header gx-1 gx-md-3">
    <Col class="col-auto">
      <CurrencyBadge currency="ROUND" />
    </Col>
    <Col class="col-auto">
      <img
        class="icon-responsive"
        src="/icons/arrow-left-right.svg"
        alt="placeholder"
      />
    </Col>
    <Col class="col-auto">
      <CurrencyBadge
        currency={baseTokenSymbol}
      />
    </Col>
  </Row>
  <Row>
    <div use:chart={chartOptions} />
  </Row>
</Card>
